/** Public folder assets — reliable in dev and production (CRA serves /public at root). */
export const GOOGLE_PLAY_BADGE = `${process.env.PUBLIC_URL}/images/google-play-badge.png`;
export const WHATSAPP_COMMUNITY_QR = `${process.env.PUBLIC_URL}/images/whatsapp-community-qr.png`;
